
namespace Matrix.Scheduling {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CalendarBaseDialog extends SiteEntityDialog<CalendarBaseRow, any> {
        protected getFormKey() { return CalendarBaseForm.formKey; }
        protected getIdProperty() { return CalendarBaseRow.idProperty; }
        protected getLocalTextPrefix() { return CalendarBaseRow.localTextPrefix; }
        protected getNameProperty() { return CalendarBaseRow.nameProperty; }
        protected getService() { return CalendarBaseService.baseUrl; }
        protected getDeletePermission() { return CalendarBaseRow.deletePermission; }
        protected getInsertPermission() { return CalendarBaseRow.insertPermission; }
        protected getUpdatePermission() { return CalendarBaseRow.updatePermission; }

        protected form = new CalendarBaseForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();
        }
    }
}